import { Type } from 'class-transformer';
import 'reflect-metadata';
import {ConsentStatus} from './consent-status';

export class CustomerClientRequest {
  @Type(() => Dealer)
  preferredDealer: Dealer;

  @Type(() => Dealer)
  preferredDealerLexus: Dealer;

  @Type(() => Dealer)
  groupDealerList: Dealer[];

  @Type(() => Dealer)
  connectedDealerList: Dealer[];

  events: ConsentStatus;
  offers: ConsentStatus;
  surveys: ConsentStatus;
  reminder: ConsentStatus;
  post: ConsentStatus;
  email: ConsentStatus;
  phone: ConsentStatus;
  messenger: ConsentStatus;

  dataSharing: ConsentStatus;
  profiling: ConsentStatus;
}

export class Dealer {
  dealerNumber: string;
  dealerGroup: string;
  name: string;
  street: string;
  postcode: string;
  city: string;
  fullCompanyName: string;
  fullCompanyNameAsList: string[];
  groupName: string;
  toyota: boolean;
  lexus: boolean;
}
